<template>
    <div>
        <div class="toggles" @click="toggles">
            <img class="icon" :src="icon" />
            <span>{{ name }}</span>
        </div>
        <iframe v-if="id == 1" class="iframe" :src="link[0].link"></iframe>
        <iframe v-if="id == 2" class="iframe" :src="link[1].link"></iframe>
    </div>
</template>
<script>
export default {
    name: "preview",
    data() {
        return {
            id: 1,
            name: "深色系风格",
            link: [
                {
                    id: 1,
                    name: "深色系风格",
                    link: "https://bbcm3f1el5s.720yun.com/vr/b1djzgwfem9",
                },
                {
                    id: 2,
                    name: "浅色系风格",
                    link: "https://www.baidu.com",
                },
            ],
            icon: "https://pro-mixed-tt.ali-cache.com/2023/nxhbase/02/70/uploads/cmsarticle/attach/2024/06/26/1719380273eKKN.png",
        };
    },
    methods: {
        toggles() {
            console.log("toggles");
            this.id = this.id == 1 ? 2 : 1;
            this.name = this.id == 1 ? this.link[0].name : this.link[1].name;
            console.log(this.link);
        },
    },
    mounted() {
        console.log(this.$route.query.link);
        // this.link = JSON.parse(this.$route.query.link);
    },
};
</script>

<style scoped lang="scss">
.toggles {
    color: #fff;
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 10px;
    padding: 8px 16px;
    position: absolute;
    top: 80%;
    left: 50%;
    transform: translate(-50%, -50%);
    .icon {
        width: 28px;
        height: 25px;
        margin-top: 5px;
        margin-right: 10px;
    }
}
.iframe {
    width: 100vw;
    height: 100vh;
}
</style>
